import { FormsModule } from '@angular/forms';
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ComponentsModule } from "@components";
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { SlickTabsModule, SlickContainerModule, SlickDropDownModule, SlickDatePickerModule, SlickFileDropModule, SlickFileListModule, SlickConfirmDialogModule, SlickButtonSpinnerModule, SlickDialogModule } from '@slick-components';
import { AutoCoverSpecsModule } from "../auto-cover-specs/auto-cover-specs.module";
import { EquipmentTrackingComponent} from "./equipment-tracking.component";

@NgModule({
    imports: [
        AutoCoverSpecsModule,
        CommonModule,
        ComponentsModule,
        FormsModule,
        NgbAccordionModule,
        SlickButtonSpinnerModule,
        SlickContainerModule,
        SlickConfirmDialogModule,
        SlickDropDownModule,
        SlickDatePickerModule,
        SlickFileDropModule,
        SlickFileListModule,
        SlickTabsModule,
        SlickDialogModule
    ],
    declarations: [
        EquipmentTrackingComponent
    ],
    exports: [
        EquipmentTrackingComponent
    ]
})

export class EquipmentTrackingModule { }
